export const IS_CONNECTED_POS = "ON_IS_CONNECTED_POS";
export const IS_CONNECTED_POS_SUCCESS = "ON_IS_CONNECTED_POS_SUCCESS";
export const IS_CONNECTED_POS_FAIL = "ON_IS_CONNECTED_POS_FAIL";

export const POS_CONNECTION = "ON_POS_CONNECTION";
export const POS_CONNECTION_SUCCESS = "ON_POS_CONNECTION_SUCCESS";
export const POS_CONNECTION_FAIL = "ON_POS_CONNECTION_FAIL";

export const UPLOAD_MENUS_FROM_POS = "UPLOAD_MENUS_FROM_POS";
export const UPLOAD_MENUS_FROM_POS_SUCCESS = "UPLOAD_MENUS_FROM_POS_SUCCESS";
export const UPLOAD_MENUS_FROM_POS_FAIL = "UPLOAD_MENUS_FROM_POS_FAIL";

export const ALLERGENS_SAVE_IN_MENU = "ALLERGENS_SAVE_IN_MENU";
export const ALLERGENS_SAVE_IN_MENU_SUCCESS = "ALLERGENS_SAVE_IN_MENU_SUCCESS";
export const ALLERGENS_SAVE_IN_MENU_FAIL = "ALLERGENS_SAVE_IN_MENU_FAIL";

export const NEW_MENU_LOAD = "NEW_MENU_LOAD";
export const NEW_MENU_LOAD_SUCCESS = "NEW_MENU_LOAD_SUCCESS";
export const NEW_MENU_LOAD_FAIL = "NEW_MENU_LOAD_FAIL";

export const MENU_LOAD = "MENU_LOAD";
export const MENU_LOAD_SUCCESS = "MENU_LOAD_SUCCESS";
export const MENU_LOAD_FAIL = "MENU_LOAD_FAIL";

export const MENU_NEW_SAVE = "MENU_NEW_SAVE";
export const MENU_NEW_SAVE_SUCCESS = "MENU_NEW_SAVE_SUCCESS";
export const MENU_NEW_SAVE_FAIL = "MENU_NEW_SAVE_FAIL";

export const MENU_UPDATE = "MENU_UPDATE";
export const MENU_UPDATE_SUCCESS = "MENU_UPDATE_SUCCESS";
export const MENU_UPDATE_FAIL = "MENU_UPDATE_FAIL";

export const ARCHIVE_MENU = "ARCHIVE_MENU";
export const ARCHIVE_MENU_SUCCESS = "ARCHIVE_MENU_SUCCESS";
export const ARCHIVE_MENU_FAIL = "ARCHIVE_MENU_FAIL";


export const onIsConnectedPOS = (restId) => ({ type: IS_CONNECTED_POS, restId});
export const onIsConnectedPOSSuccess = (data) => ({ type: IS_CONNECTED_POS_SUCCESS, data});
export const onIsConnectedPOSFail = (e) => ({ type: IS_CONNECTED_POS_FAIL, e});

export const onPOSConnection = (restId) => ({type: POS_CONNECTION, restId});
export const onPOSConnectionSuccess = (data) => ({ type: POS_CONNECTION_SUCCESS,data,});
export const onPOSConnectionFail = (e) => ({ type: POS_CONNECTION_FAIL, e });

export const onUploadMenusFromPOS = (restId) => ({ type: UPLOAD_MENUS_FROM_POS, restId});
export const onUploadMenusFromPOSSuccess = (data) => ({ type: UPLOAD_MENUS_FROM_POS_SUCCESS, data });
export const onUploadMenusFromPOSFail = (e) => ({ type: UPLOAD_MENUS_FROM_POS_FAIL, e });

export const onAllergensSaveInMenu = (allergens) => ({type: ALLERGENS_SAVE_IN_MENU,allergens});
export const onAllergensSaveInMenuSuccess = (data) => ({ type: ALLERGENS_SAVE_IN_MENU_SUCCESS, data });
export const onAllergensSaveInMenuFail = (e) => ({ type: ALLERGENS_SAVE_IN_MENU_FAIL, e });

export const onNewMenuLoad = () => ({ type: NEW_MENU_LOAD });
export const onNewMenuLoadSuccess = (data) => ({ type: NEW_MENU_LOAD_SUCCESS,data,});
export const onNewMenuLoadFail = (e) => ({ type: NEW_MENU_LOAD_FAIL, e });

export const onMenuLoad = (restId) => ({ type: MENU_LOAD, restId});
export const onMenuLoadSuccess = (data) => ({ type: MENU_LOAD_SUCCESS, data });
export const onMenuLoadFail = (e) => ({ type: MENU_LOAD_FAIL, e });

export const onMenuNewSave = (values,selected,isCheckAllFutureLocations) => ({ 
    type: MENU_NEW_SAVE, values,selected,isCheckAllFutureLocations,});
export const onMenuNewSaveSuccess = (data) => ({ type: MENU_NEW_SAVE_SUCCESS, data,});
export const onMenuNewSaveFail = (e) => ({ type: MENU_NEW_SAVE_FAIL, e });

export const onMenuUpdate = (restId,values,selected,isCheckAllFutureLocations) => ({ 
        type: MENU_UPDATE, restId,values,selected,isCheckAllFutureLocations});
export const onMenuUpdateSuccess = (data) => ({ type: MENU_UPDATE_SUCCESS, data,});
export const onMenuUpdateFail = (e) => ({ type: MENU_UPDATE_FAIL, e });

export const onArchiveMenu = (archived,menuId) => ({ type: ARCHIVE_MENU, archived, menuId });
export const onArchiveMenuSuccess = (data) => ({ type: ARCHIVE_MENU_SUCCESS, data });
export const onArchiveMenuFail = (e) => ({ type: ARCHIVE_MENU_FAIL, e });
